<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="mx-auto box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Check Homework</strong>
        </v-toolbar-title>
      </v-toolbar>
      <br />
      <v-card max-width="700" class="mx-auto">
        <v-container fluid>
          <v-row dense align="center">
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Academic Year&nbsp; : {{ this.ay }}</v-card-text
                >
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Standard &nbsp; : {{ this.standard }}</v-card-text
                >
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Division &nbsp; : {{ this.division }}</v-card-text
                >
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold"
                  >Subject &nbsp; : {{ this.subject }}</v-card-text
                >
              </v-row>
            </v-card>
          </v-row>
        </v-container>
      </v-card>

      <v-card class="mx-auto box">
        <v-container fluid>
          <v-row>
            <div>
              Title :
              <!-- <span style="color:indigo"> -->
              <span>
                <strong>
                  {{ this.title }}
                </strong>
              </span>

              <br />

              Assign Date :
              <!-- <span style="color:indigo"> -->
              <span>
                <strong>
                  {{ this.assign_date }}
                </strong>
              </span>

              <br />

              Description :
              <strong>
                <!-- <span style="color:indigo"> -->
                <v-textarea readonly outlined v-model="this.description">
                </v-textarea>
              </strong>
              <!-- <strong> 
                                {{this.description}}
                            </strong>  -->
              <!-- </span> -->
              <!-- </div>
                <div class="text-overline mb-4"> -->
              Attachments :
              <a
                target="_blank"
                :href="basepath + this.attachments"
                v-if="this.attachments != null"
              >
                <!-- <span style="color:indigo"> -->
                <span>
                  <strong> Attachment </strong>
                </span>
              </a>
              <span v-if="this.attachments == null">
                <!-- <strong>--</strong> -->
              </span>

              <br />
              Modal Answer :
              <a target="_blank" :href="basepath + this.model_answer" v-if="this.model_answer != null">
                <!-- <span style="color:indigo"> -->
                <span>
                  <strong> Modal Answer </strong>
                </span>
              </a>
              <span v-if="this.model_answer == null">
                <strong>--</strong>
              </span>

              <br />

              Due Date :
              <!-- <span style="color:indigo"> -->
              <span style="color: red">
                <strong>
                  {{ this.due_date }}
                </strong>
              </span>

              <br />

              Total Marks :
              <!-- <span style="color:indigo"> -->
              <span>
                <strong>
                  {{ this.total_marks }}
                </strong>
              </span>
            </div>
          </v-row>
        </v-container>
      </v-card>
      <br />
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <span
            v-if="!is_assignment"
            style="font-size: 14px; font-style: italic; color: red"
            >*This is Material upload, Remarks and Marks cannot be given!</span
          >
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="submitted_homework_list"
          :search="search"
          class="mytable"
        >
          <template v-slot:[`item.teacher_remark`]="{ item }">
            <div>
              <input
                placeholder=""
                class="input1"
                type="text"
                :disabled="!is_assignment"
                v-model="item.teacher_remark"
                style="width: 120px"
              />
            </div>
          </template>

          <template v-slot:[`item.marks`]="{ item }">
            <div>
              <input
                class="input1"
                type="number"
                :disabled="!is_assignment"
                v-model="item.marks"
                style="width: 50px"
              />
            </div>
          </template>

          <template v-slot:[`item.toggle`]="{ item }">
            <v-container fluid>
              <v-row>
                <v-col cols="6">
                  <v-switch
                    :disabled="!is_assignment"
                    color="green"
                    value
                    input-value="true"
                    v-model="item.checked"
                    @change="toggle(item)"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <div>
              <v-btn
                color="green"
                :disabled="!is_assignment"
                @click="updateHomework(item)"
                >Save</v-btn
              >
            </div>
          </template>

          <!--submission_file-->
          <template v-slot:[`item.submission_file`]="{ item }">
            <div>
              <a
                v-if="item.submission_file != null"
                target="_blank"
                :href="basepath + item.submission_file"
              >
                <span style="color: indigo">
                  <strong> Answer File </strong>
                </span>
              </a>
              <span v-if="item.submission_file == null">
                <strong> -- </strong>
              </span>
            </div>
          </template>

          <template v-slot:[`item.checked`]="{ item }">
            <span v-if="item.checked">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
        </v-data-table>
      </v-card>
    </v-card>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data() {
    return {
      dialog: false,
      overlay: false,
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay: null,
      standard: null,
      division: null,
      subject: null,
      due_date: null,
      title: null,
      attachments: null,
      assign_date: null,
      due_date: null,
      total_marks: null,
      description: null,
      basepath: null,
      submitted_homework_list: [],
      is_assignment: false,
      headers: [
        {
          text: "Sr. No.",
          value: "srno",
          align: "center",
        },
        {
          text: "PRN",
          value: "PRN",
        },
        {
          text: "Roll No",
          value: "roll_no",
        },
        {
          text: "Name",
          value: "learner_name",
        },
        {
          text: "Submission Date",
          value: "submission_date",
        },
        {
          text: "Submission File",
          value: "submission_file",
        },
        {
          text: "Answer Text",
          value: "answer",
        },
        {
          text: "Evaluation Date",
          value: "evaluation_date",
        },
        {
          text: "Software Remarks",
          value: "sw_remark",
        },
        {
          text: "Teacher Remarks",
          value: "teacher_remark",
        },
        {
          text: "Marks",
          value: "marks",
        },
        {
          text: "Is Checked?",
          value: "checked",
          align: "center",
        },
        { text: "Disable Submission", value: "toggle", sortable: false },
        { text: "Actions", value: "action", sortable: false },
      ],
    };
  },
  mounted() {
    this.onLoad();
    this.basepath = localStorage.getItem("awspath");
  },
  methods: {
    toggle(item) {
      //window.alert(JSON.stringify(item.checked))
      const data = {
        submitted_homework_id: item.id,
        togglecheck: item.checked,
      };
      this.overlay = true;
      axios
        .post("/Homework/toggle_is_checked", data)
        .then((res) => {
          // if(res.data.code == "SUCCESS"){
          //     this.showSnackbar("#4caf50", "Homework Status Changed!"); // show snackbar
          // }
          if (res.data.check_status == "true") {
            this.showSnackbar("#b71c1c", "Submission is disabled!");
          } else if (res.data.check_status == "false") {
            this.showSnackbar("#4caf50", "Submission is enabled...");
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    updateHomework(item) {
      //window.alert(JSON.stringify(item))
      // if(item.marks < 0){
      //   this.showSnackbar("#b71c1c", "Marks Should Be Greater Than 0");
      //   return
      // }
      if (item.marks > this.total_marks) {
        this.showSnackbar(
          "#b71c1c",
          "Marks Cannot Be Greater Than Total Marks"
        );
        return;
      } else {
        const data = {
          submitted_homework_id: item.id,
          teacher_remark: item.teacher_remark,
          marks: item.marks,
        };
        this.overlay = true;
        axios
          .post("/Homework/save_teacher_evaluation", data)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Marks Updated Succesfully"); // show snackbar
              this.onLoad();
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      }
    },
    onLoad() {
      //   console.log("this.$store.getters.homework_id")
      //   console.log(this.$store.getters.homework_id)
      if (this.$store.getters.homework_id == null) {
        this.$router.push({ name: "teacher-add-homework" });
      }
      const data = {
        homework_id: this.$store.getters.homework_id,
      };
      this.overlay = true;
      axios
        .post("/Homework/fetch_submitted_homeworks", data)
        .then((res) => {
          this.overlay = false;
          (this.ay = res.data.academicyear),
            (this.standard = res.data.standard),
            (this.division = res.data.division),
            (this.subject = res.data.subject),
            (this.submitted_homework_list = res.data.submitted_homework_list),
            (this.title = res.data.title),
            (this.attachments = res.data.attachments),
            (this.assign_date = res.data.assign_date),
            (this.due_date = res.data.due_date),
            (this.description = res.data.description),
            (this.total_marks = res.data.total_marks);
          this.is_assignment = res.data.is_assignment;
          //window.alert(JSON.stringify(this.submitted_homework_list))
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

<style scoped>
.input1 {
  border: 1px round #000;
  height: 30px;
  border-radius: 10px;
  background: whitesmoke;
  color: black;
  text-align: center;
}
</style>